import Vue, { createApp } from 'vue'
import { createPinia } from 'pinia'
import { ref } from 'vue';
import App from './App.vue'
import { createI18n, useI18n } from 'vue-i18n'
import router from './router'

import LoadingComponent from '@/components/loadingComponent.vue'
import AlertModal from "@/components/AlertModalFeedback.vue";

import './assets/tailwind.css'
import 'flowbite';
import ValidationError from "@/components/ValidationError.vue";

import it from '../../EshJSLib/locales/it.json'
import en from '../../EshJSLib/locales/en.json'

import VueGtag from 'vue-gtag';

const i18n = createI18n({
    locale: 'it', // set locale
    fallbackLocale: 'en',
    legacy: false,
    globalInjection: true,
    messages: {
        en,
        it,
    },

});
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
import "vue-select/dist/vue-select.css";
/* import font awesome icon component */
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import vSelect from "vue-select";
/* import specific icons */
import { faUserDoctor, faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faSave } from '@fortawesome/free-solid-svg-icons'
import { faPaperclip } from '@fortawesome/free-solid-svg-icons'
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { faUpDown } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faSquare } from '@fortawesome/free-solid-svg-icons'
import { faCircleArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
/* add icons to the library */
library.add(faCircleArrowDown)
library.add(faUserSecret)
library.add(faDownload)
library.add(faSave)
library.add(faPlus)
library.add(faPaperclip)
library.add(faLock)
library.add(faPen)
library.add(faInfo)
library.add(faUpDown)
library.add(faTrash)
library.add(faUserDoctor)
library.add(faSquare)
library.add(faEnvelope)
library.add(faGlobe)
library.add(faArrowDown)
library.add(faSearch)
library.add(faArrowUpRightFromSquare)
library.add(faPhone)
library.add(faPrint)
library.add(faExclamation)
library.add(faEye)
library.add(faLocationDot)
library.add(faCircleQuestion)

faArrowUpRightFromSquare


import { patientStore } from './store/patient'

const pinia = createPinia()



// Create a reactive data store
export const dataStore = ref(null);


const app = createApp(App)

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(VueGtag, {
    config: { 
        id: "G-4SJ2E8K3D5",
      },
}, router)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component("v-select", vSelect);
app.component('font-awesome-layers', FontAwesomeLayers)
app.component('font-awesome-layer-text', FontAwesomeLayersText)
app.component('ValidationError', ValidationError)
app.component('LoadingComponent', LoadingComponent)
app.component('AlertModal', AlertModal)
app.mount('#app')


import { authStore } from './store/authorize'
import { CurrentUser } from '@/../../EshJSLib/models/currentuser';
const store = authStore();


router.beforeEach((to, from, next) => {

    if (to.name === 'Login') {
        next()
    }
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    const expires_at = new Date(localStorage.getItem('expires_at'));
    const now = new Date();

    //now.setHours(now.getHours() + 18)

    if (!token || !user || expires_at < now) {
        next({ name: "Login" })
    } else {
        store.refreshState(token, user)
        next()
    }
})